import $ from 'jquery';
import Swiper from 'swiper';

if ($('.js-event-nav .swiper-slide').length > 2) {
  const $eventNavSlider = new Swiper('.js-event-nav .swiper-container', {
    slidesPerView: 'auto',
    grabCursor: true,
    freeMode: true,
    // Navigation arrows
    navigation: false,
  });
}
